import * as THREE from 'three';
import { ControlPointObjectType, LineObjectType } from '../types';

interface Props {
  startPoint: THREE.Vector3;
  endPoint: THREE.Vector3;
  intersectedCircles: Array<ControlPointObjectType>;
  startObject: ControlPointObjectType;
}
export class LineObject extends THREE.Line implements LineObjectType {
  private directionRay = new THREE.Vector3(0, -1, 0);
  private planeIntersected: THREE.Mesh;
  // material = new THREE.LineBasicMaterial({ color: 0x000000, linewidth: 1 });
  material = new THREE.LineDashedMaterial({
    color: '#3c3c3c',
    linewidth: 1,
    // scale: 0.1,
    dashSize: 0.003,
    gapSize: 0.001,
  });
  startPoint: THREE.Vector3;
  endPoint: THREE.Vector3;
  raycaster = new THREE.Raycaster();
  intersectedCircles;
  selectIntersectedObject: ControlPointObjectType | null;
  startObject;

  constructor({ startPoint, endPoint, intersectedCircles, startObject }: Props) {
    super();
    this.type = 'line_step_object';
    this.name = 'line_step_object';
    this.startPoint = startPoint;
    this.endPoint = endPoint;
    this.intersectedCircles = intersectedCircles;
    this.selectIntersectedObject = null;
    this.startObject = startObject;
    this.planeIntersected = this.getRoomIntersected();

    this.buildGeometry();
  }

  buildGeometry() {
    if (this.geometry) {
      this.geometry.dispose();
    }
    this.geometry = new THREE.Geometry().setFromPoints([this.startPoint, this.endPoint]);
    this.computeLineDistances();
    this.planeIntersected = this.getRoomIntersected();
    this.intersectedCircles.push();
  }
  updateLineGeometry(newPos: THREE.Vector3) {
    const geomLine = this.geometry as THREE.Geometry;
    const Y = geomLine.vertices[1].y;
    this.raycaster.set(newPos.setY(0.5), this.directionRay);
    const intersected = this.raycaster.intersectObjects([
      ...this.intersectedCircles,
      this.planeIntersected,
    ]);

    if (intersected.length > 0) {
      geomLine.vertices[1].copy(newPos).setY(Y);
      geomLine.verticesNeedUpdate = true;
      if (intersected.length === 2) {
        this.selectIntersectedObject = intersected[0].object as ControlPointObjectType;
      } else {
        this.selectIntersectedObject = null;
      }
    }
  }
  removeLineObject() {
    if (this.geometry) {
      this.geometry.dispose();
    }
    if (this.material) {
      this.material.dispose();
    }
    this.parent?.remove(this);
  }

  private getRoomIntersected(): THREE.Mesh {
    const geometry = new THREE.Geometry();

    const points2D: Array<THREE.Vector2> = [];
    for (let i = 0; i < this.intersectedCircles.length; i++) {
      const point = this.intersectedCircles[i].position.clone().setY(-20);
      geometry.vertices.push(point);
      points2D.push(new THREE.Vector2(point.x, point.z));
    }
    // const points3D: Array<THREE.Vector3> = this.intersectedCircles.map(item =>
    //   item.position.clone()
    // );
    //
    // const points2D: Array<THREE.Vector2> = points3D.map(
    //   point => new THREE.Vector2(point.x, point.z)
    // );
    // for (let i = 0; i < points3D.length; i++) {
    //   geometry.vertices.push(points3D[i]);
    // }
    const triangles = THREE.ShapeUtils.triangulateShape(points2D, []);
    for (let i = 0; i < triangles.length; i++) {
      geometry.faces.push(new THREE.Face3(triangles[i][0], triangles[i][1], triangles[i][2]));
    }
    const mat = new THREE.MeshBasicMaterial({ color: '#026602', side: THREE.DoubleSide });
    return new THREE.Mesh(geometry, mat);
  }
}
